import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router';


function Salesforce() {
  const features = [
    {
      icon: '/p1.svg',
      title: 'Client-Centric Approach',
      description: 'We understand your business goals before coding begins.',
    },
    {
      icon: '/certificate.svg',
      title: 'Certified Experts',
      description: 'A team of Salesforce-certified developers and consultants.',
    },
    {
      icon: '/p2.svg',
      title: 'Agile Methodology',
      description: 'Regular updates, flexibility, and faster delivery.',
    },
    {
      icon: '/p3.svg',
      title: 'Global Reach',
      description: 'Trusted by businesses across the USA, India, and beyond.',
    },
    {
      icon: '/p4.svg',
      title: 'Innovation-Driven',
      description:
        'AI, analytics, and automation integrated into Salesforce ecosystems.',
    },
    {
      icon: '/p5.svg',
      title: 'Proven Success',
      description:
        'Delivering Salesforce solutions that improve ROI, customer satisfaction, and business agility.',
    },
  ];

  return (
    <div className="w-full font-kumbh bg-white mt-8 sm:mt-8 md:mt-2 xl:mt-10 overflow-x-hidden">
      {/* Hero Section */}
      <section
        className="relative w-full min-h-[550px] md:mt-8 flex flex-col md:flex-row items-center justify-between overflow-hidden py-10 px-6 md:px-16 lg:px-28"
        style={{
          backgroundImage: "url('/worldmap.svg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {/* Left Content */}
        <div className="relative z-10 flex-1 flex flex-col space-y-6 items-start justify-center text-center md:text-left">
          <h2 className="text-3xl mt-6 md:mt-0 sm:text-4xl md:text-6xl lg:text-[71.5px] font-semibold text-[#EF0E0E] leading-snug mb-6">
            Salesforce <br className="hidden sm:block" />
            <span className="block mt-2">Solutions</span>
          </h2>

             <Link to="/contact"><button className=" px-5 py-4 md:px-7 border border-black text-black hover:bg-gray-200 transition-all duration-200">
      Consult With Us <span className="ml-2">↗</span>
    </button></Link>
        </div>

        {/* Right Image */}
        <div className="mt-10 md:mt-14 md:flex-1 flex justify-center md:justify-end relative z-0">
          <img
            src="/Salesforce.svg"
            alt="Salesforce"
            className="w-64 sm:w-80 md:w-[420px] lg:w-[500px] h-auto object-contain"
          />
        </div>
      </section>

      {/* Transform Section */}
      <section className="mx-auto px-6 sm:px-12 md:px-24 py-16 bg-[#F4F6FB] grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div className="space-y-6 text-center md:text-left">
          <h2 className="text-xl sm:text-2xl md:text-3xl justify-start whitespace-nowrap xl:text-4xl md:ml-3 font-semibold font-kumbh xl:leading-[57.20px] text-black">
            Transform Your Business with <br /> Doelsoft Salesforce Solutions
          </h2>
          <p className="text-black justify-start text-lg md:ml-4 sm:text-xl  font-inter font-normal leading-8">
            In today’s competitive market, customer relationships define
            success. At Doelsoft, we leverage the power of Salesforce CRM to help
            businesses improve customer engagement, automate processes, and
            accelerate growth.
          </p>
          <p className="text-black justify-start text-lg md:ml-4 sm:text-xl  font-inter font-normal leading-8">
            As a trusted Salesforce consulting and development partner in the USA
            & India, we deliver tailored CRM solutions that align with your
            business goals — whether you’re a startup or a large enterprise.
          </p>
        </div>
        <div className="flex justify-center md:-mb-40">
          <img
            src="Salesforceteam.svg"
            alt="Salesforce Team"
             className="w-auto h-auto md:w-[620px] md:h-[620px] p-4"
          />
        </div>
      </section>

      {/* Services Section */}
      <section className="container mx-auto px-6 sm:px-10 lg:px-20 py-12 grid gap-10 md:grid-cols-2 items-center">
        {/* Left Image */}
        <div className="flex justify-center md:ml-8 md:justify-start">
          <img
            src="Saleforcemen.svg"
            alt="Business Team"
            className="w-full max-w-xs sm:max-w-sm md:max-w-md"
          />
        </div>

        {/* Right Content */}
        <div className="space-y-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-kumbh font-semibold text-black leading-[57.20px]">
            🌟 Our Salesforce Services
          </h2>

          <div className="space-y-6">
            {[
              {
                src: '/m1.svg',
                title: 'Salesforce Consulting',
                desc: 'Strategic guidance to align Salesforce with your business objectives.',
              },
              {
                src: '/m2.svg',
                title: 'Salesforce Implementation',
                desc: 'End-to-end setup of Sales Cloud, Service Cloud, Marketing Cloud, and more.',
              },
              {
                src: '/m3.svg',
                title: 'Customization & Development',
                desc: 'Custom objects, workflows, and Apex coding for your unique processes.',
              },
              {
                src: '/m4.svg',
                title: 'Integration Services',
                desc: 'Seamless integration with ERP, HRMS, financial systems, and third-party apps.',
              },
              {
                src: '/m5.svg',
                title: 'Salesforce AppExchange Development',
                desc: 'Build and deploy apps that enhance functionality.',
              },
              {
                src: '/m6.svg',
                title: 'Migration to Salesforce',
                desc: 'Smooth transition from legacy CRMs to Salesforce with minimal downtime.',
              },
              {
                src: '/m6.svg',
                title: 'Support & Maintenance',
                desc: 'Continuous monitoring, upgrades, and user support.',
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="flex flex-col sm:flex-row gap-4 items-start"
              >
                <div className="flex-shrink-0 bg-white border border-gray-300 p-4  flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 mx-auto sm:mx-0">
                  <img
                    src={item.src}
                    alt={item.title}
                    className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                  />
                </div>
                <div className="text-center sm:text-left">
                  <h3 className="text-lg sm:text-xl font-semibold text-black font-kumbh leading-8">
                    {item.title}
                  </h3>
                  <p  className="text-zinc-800 text-base sm:text-lg font-inter font-normal leading-7  whitespace-pre-line">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
    
      <section className="bg-[#F4F6FB] py-10">
        <div className="px-6 sm:px-12 md:px-20 md:ml-7 text-center md:text-left space-y-4">
          <h1  className="text-3xl sm:text-4xl font-bold"> 🏢 Industries We Empower with Salesforce</h1>
          <p className="text-gray-600 md:ml-2"> Doelsoft enables businesses across industries to unlock Salesforce
            potential:</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 md:ml-9 py-10 px-6 sm:px-12 md:px-20 gap-6">
          {[
            {
              src: '/ecommerce.svg',
              title: 'E-commerce & Retail',
              desc: 'Personalized shopping experiences, customer journeys, loyalty management.',
            },
            {
              src: '/health_care.svg',
              title: 'Healthcare Apps',
              desc: 'Patient engagement, HIPAA-compliant workflows, health cloud.',
            },
            {
              src: '/finance.svg',
              title: 'Banking & FinTech Apps',
              desc: 'Customer 360, wealth management, compliance automation.',
            },
            {
              src: '/education.svg',
              title: 'Education Apps',
              desc: 'Student lifecycle management, admissions, alumni engagement.',
            },
            {
              src: '/travel.svg',
              title: 'Travel & Hospitality Apps',
              desc: 'Customer insights, service automation, booking management.',
            },
            {
              src: '/Manufactue.svg',
              title: 'Manufacturing & Logistics',
              desc: 'Sales pipeline visibility, partner management, inventory tracking.',
            },
            {
              src: '/realestate.svg',
              title: 'Real Estate',
              desc: 'Lead management, property tracking, customer service excellence.',
            },
          ].map((item, idx) => (
            <div
              key={idx}
              className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 items-center hover:shadow-md transition"
            >
              <img src={item.src} alt={item.title} className="w-full h-48 object-cover" />
              <div className="sm:pl-4  sm:mt-0 border border-black h-48 p-4 sm:p-8 text-center sm:text-left">
                <h3 className="font-semibold text-lg text-zinc-950 capitalize leading-6">{item.title}</h3>
                <p className="text-zinc-950 text-base  font-normal font-inter leading-6 mt-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Talent Pool Section */}
      <section className="bg-white py-12">
        <div className="md:ml-8 px-6 sm:px-10 md:px-20 mb-10">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-kumbh font-semibold mb-4 leading-[66px]">
            👨‍💻 Doelsoft Salesforce Talent Pool
          </h1>
          <p className="text-lg justify-start sm:text-xl md:ml-2 text-black font-inter font-normal leading-8">
            Our Salesforce-certified experts ensure maximum ROI:
          </p>
        </div>

        <div className="container mx-auto px-6 sm:px-10 md:px-20 md:ml-8 max-w-7xl grid gap-8 sm:grid-cols-2">
          {[
            {
              src: '/s1.svg',
              desc: 'Salesforce Developers skilled in Apex, Visualforce, Lightning Web Components.',
            },
            {
              src: '/s2.svg',
              desc: 'Salesforce Administrators to optimize workflows, dashboards, and data management.',
            },
            {
              src: '/s3.svg',
              desc: 'CRM Consultants helping you design customer-first business strategies.',
            },
            {
              src: '/s4.svg',
              desc: 'Integration Specialists connecting Salesforce with APIs, ERP, and external apps.',
            },
            {
              src: '/s5.svg',
              desc: 'Quality Analysts ensuring error-free, secure, and compliant Salesforce deployments.',
            },
          ].map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 p-6 bg-white border border-gray-200  shadow-md hover:shadow-lg transition"
            >
              <img
                src={item.src}
                alt={item.desc}
                className="w-12 h-12 sm:w-16 sm:h-16 flex-shrink-0 mx-auto sm:mx-0"
              />
              <p className="text-back justify-start font-medium text-base sm:text-lg font-kumbh leading-6">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="bg-[#F4F6FA] py-12 px-6 sm:px-10 lg:px-20 font-sans" style={{marginBottom:"-44px"}}>
        <div className="max-w-7xl mx-auto flex flex-col-reverse xl:flex-row items-center gap-10">
          <div className="flex-1 space-y-6 ">
            <h1 className="text-2xl md:text-3xl ml-auto xl:ml-[-29px] xl:text-4xl  justify-start md:whitespace-nowrap font-kumbh font-semibold mb-8 xl:leading-[57.20px]">
              💡 Why Choose Doelsoft for Salesforce Services?
            </h1>

            <div className="space-y-6 md:-ml-5">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row items-start gap-4  p-4  "
                >
                  <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center border border-white  bg-white mx-auto sm:mx-0">
                    <img
                      src={feature.icon}
                      alt={feature.title}
                      className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                    />
                  </div>
                  <div className="text-center sm:text-left ">
                    <h4 className="text-lg justify-start sm:text-xl font-semibold font-kumbh text-black leading-8">
                      {feature.title}
                    </h4>
                    <p className="text-gray-600 text-sm sm:text-base">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="flex-1 flex justify-center">
            <img
              src="/youngsalesmen.svg"
              alt="Man holding toy plane"
              className="w-full h-auto xl:w-[619px] xl:h-[818px]  "
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative w-full bg-cover bg-center text-center py-16 md:h-[568px] sm:py-20 md:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden" style={{ backgroundImage: "url('/Background2.svg')",marginTop:"1px" } } > {/* Decorative Vectors */}
        <img src="/Vectors.svg" alt="vector" className="absolute left-6 sm:left-14 top-8 sm:top-10 h-20 sm:h-28 md:h-32 w-20 sm:w-28 md:w-32 object-contain opacity-70 z-30" /> 
        <img src="/left.svg" alt="left" className="absolute left-10 sm:left-20 bottom-10 sm:top-70 w-3 sm:w-4 object-contain opacity-70 z-30" /> 
        <img src="/right.svg" alt="right" className="absolute right-10 sm:right-40 lg:right-72 top-6 sm:top-12 w-10 sm:w-16 md:w-20 object-contain opacity-70 z-30" /> {/* Dark overlay */}
         <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/80 to-black/90"></div> {/* Main Content */} 
         <div className="relative max-w-3xl mx-auto md:mt-8 text-white z-10 flex flex-col items-center justify-center space-y-5 sm:space-y-7 md:space-y-8"> 
           <h2 className="text-xl md:text-2xl lg:text-3xl xl:text-[56px] font-manrope font-bold whitespace-nowrap leading-snug px-2">🌍 Unlock Salesforce Power with Doelsoft </h2>
            <p className="text-lg lg:text-[28px] xl:text-[30px] font-inter text-gray-200 leading-relaxed px-2"> 👉 Partner with Doelsoft – Your Salesforce consulting and development company in the USA & India. </p>
             <Link to="/contact"> <button className="flex items-center gap-2  bg-red-600 hover:bg-gray-600 text-white font-medium px-5 sm:px-8 py-3 sm:py-6 text-sm sm:text-xl  shadow-lg transition-all duration-300 ease-in-out">
                        Talk to an Expert{" "}
                        <ArrowUpRight
                          className="border border-white rounded-full p-1"
                          size={24}
                        />
                      </button> </Link>
              </div> 
              </section>
    </div>
  );
}

export default Salesforce;
